/**
 * Hash router for aiperth.co
 * Routes: #/home #/quiz #/basics #/usecases #/walkthroughs
 *          #/prompts #/booster #/tools #/safety #/plan
 */
const ROUTES = new Set([
  "home",
  "quiz",
  "basics",
  "usecases",
  "walkthroughs",
  "prompts",
  "booster",
  "tools",
  "safety",
  "plan",
]);

const TITLES = {
  home: "Start Here",
  quiz: "Find Your Starting Point",
  basics: "AI Basics",
  usecases: "Use Cases",
  walkthroughs: "Walkthroughs",
  prompts: "Prompt Library",
  booster: "Prompt Booster",
  tools: "Tools & Costs",
  safety: "Staying Safe",
  plan: "30-Day Plan",
};

function parseHash() {
  const raw = (location.hash || "#/home").replace(/^#\/?/, "").split("?")[0].split("/")[0];
  return ROUTES.has(raw) ? raw : "home";
}

export function currentRoute() {
  return parseHash();
}

export function navigate(section, { replace = false } = {}) {
  const id = ROUTES.has(section) ? section : "home";
  const next = `#/${id}`;
  if (replace) history.replaceState(null, "", next);
  else if (location.hash !== next) location.hash = next;
  else applyRoute(id);
}

function applyRoute(section) {
  // stopDictation is defined in main.js as a let reassignment — call if present
  if (typeof window.__aiadvStopDictation === "function") {
    window.__aiadvStopDictation(section);
  }

  document.querySelectorAll(".page").forEach((p) => p.classList.remove("active"));
  const page = document.getElementById("page-" + section) || document.getElementById("page-home");
  page.classList.add("active");

  document.querySelectorAll(".nav-btn, .mobile-nav-link").forEach((b) => {
    const nav = b.dataset.nav;
    b.classList.toggle("active", nav === section);
    if (b.classList.contains("nav-btn")) {
      b.setAttribute("aria-current", nav === section ? "page" : "false");
    }
  });

  document.title = `${TITLES[section] || "aiperth.co"} — aiperth.co`;

  // Focus main heading for a11y
  const h = page.querySelector("h1");
  if (h) {
    if (!h.hasAttribute("tabindex")) h.setAttribute("tabindex", "-1");
    try {
      h.focus({ preventScroll: true });
    } catch {
      /* ignore */
    }
  }

  window.scrollTo({ top: 0 });

  // Close mobile drawer
  document.body.classList.remove("nav-open");
  const toggle = document.getElementById("navToggle");
  if (toggle) toggle.setAttribute("aria-expanded", "false");
}

// Bridge original goTo(data-nav) clicks into the hash router
document.addEventListener("click", (e) => {
  // Never hijack external/share links
  if (e.target.closest("a.header-share-qr, a[href^='/share'], a[href^='http']")) return;
  const nav = e.target.closest("[data-nav]");
  if (!nav) return;
  const section = nav.getAttribute("data-nav") || nav.dataset.nav;
  if (!section) return;
  e.preventDefault();
  navigate(section);
});

window.addEventListener("hashchange", () => applyRoute(parseHash()));

// Initial route
if (!location.hash || location.hash === "#") {
  history.replaceState(null, "", "#/home");
}
applyRoute(parseHash());

// Expose for debugging / handoff
window.__aiadvNavigate = navigate;
